"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asPreview = exports.withPreview = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var RichTextContext_1 = require("./RichTextContext");

var withDefaults_1 = __importDefault(require("./withDefaults"));

var PluginButton_1 = __importDefault(require("./components/PluginButton"));

var BaseRichTextPreview = function BaseRichTextPreview(props) {
  var components = props.components,
      ui = props.ui;
  var finalComponents = withDefaults_1.default(components);
  var PreviewWrapper = RichTextContext_1.getUI(ui).PreviewWrapper;
  return react_1.default.createElement(PreviewWrapper, null, Object.values(finalComponents) // eslint-disable-next-line react/no-array-index-key
  .map(function (C, i) {
    return C.hoverButton && react_1.default.createElement(PluginButton_1.default, {
      key: i,
      icon: C.hoverButton.icon,
      componentName: "Button"
    });
  }));
};

var asPreview = fclasses_1.addProps({
  preview: 1
});
exports.asPreview = asPreview;
var withPreview = fclasses_1.flowIf(fclasses_1.hasProp('preview'))(core_1.withoutProps(['preview']), fclasses_1.replaceWith(BaseRichTextPreview));
exports.withPreview = withPreview;